/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Home/ContributorHome.tsx.
 */

// src/pages/Dashboard/Contributor/ContributorHome.tsx
import React from "react";
import "../Contributor.css";
import "./ContributorHome.css";
import DataCollectionSection from "./components/DataCollectionSection";
import DataEntryMethodSection from "./components/DataEntryMethodSection";
import HowToSubmitSection from "./components/HowToSubmitSection";
import DataReliabilitySection from "./components/DataReliabilitySection";
import AnalysisBanner from "../../../../components/common/AnalysisBanner";
import Button from "../../../../components/common/Button";

interface ContributorHomeProps {
  onNavigateToDataInput: () => void;
}

const ContributorHome: React.FC<ContributorHomeProps> = ({ onNavigateToDataInput }) => {
  return (
    <div className="contributor-home-container">
      {/* Header Section */}
      <AnalysisBanner
        title="Welcome to the ICoMEC Contributor Portal"
      />

      {/* Content Section */}
      <div className="home-content">
        <h1 className="home-content-title">
          Indian Construction Materials Embodied Carbon Database
        </h1>
        <p className="home-content-description">
          The ICoMEC Contributor Portal enables manufacturers, researchers, and institutions to submit
          embodied carbon datasets for Indian construction materials. All submitted data contributes
          to building a transparent, reliable, and India-specific embodied carbon database to support
          Life Cycle Assessment (LCA) studies. As a contributor, you are responsible for ensuring that
          the data provided is accurate, well-documented, and traceable.
        </p>

        {/* Section 1: What data does ICOMEC collect? */}
        <DataCollectionSection />

        {/* Section 2: Data entry method */}
        <DataEntryMethodSection />

        {/* Section 3: How to submit data */}
        <HowToSubmitSection />

        {/* Section 4: Data Reliability assessment and Contributor responsibility */}
        <DataReliabilitySection />

        {/* Start Contributing Button */}
        <div className="home-cta-section">
          <Button
            label="Start Contributing"
            onClick={onNavigateToDataInput}
            type="button"
            variant="default"
          />
        </div>
      </div>
    </div>
  );
};

/** React component — Contributor Home. */
export default ContributorHome;